import { call, put } from "redux-saga/effects";
import { AxiosError, AxiosResponse } from "axios";

// Response / Request
import { Result } from "@models/common/resultResponse";
import { KeyValue } from "@/main/models/common";

// Redux
import { GetTimeZonesUser, saveTimeZonesUser } from "./index";

// Api's
import { timeZoneApi } from "../../api";
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from "@/main/services/utils";

export function* getTimeZonesUserSaga(action: GetTimeZonesUser) {
	try {
		const response: AxiosResponse<Result<KeyValue[]>> = yield call(timeZoneApi.getDomain, action.payload.request);
		if (response.data.result) {
			yield put(saveTimeZonesUser(response.data.result, false, null));
		}
	} catch (exception) {
		if (exception instanceof AxiosError) {
			const resultError = errorBoundaryReduxSaga(exception);
			renderErrorReduxSaga(resultError);

			yield put(saveTimeZonesUser(null, true, resultError.messagesDataError));
		}
	}
}
